// extracted by mini-css-extract-plugin
export var container = "_5b-0";
export var disabled = "_5b-4";
export var fullWidth = "_5b-3";
export var lined = "_5b-1";
export var selected = "_5b-5";
export var tab = "_5b-2";